import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../../utils/baseQueryFn';


const driverReviewAPI = createApi({
    reducerPath: "driverReviewAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllDriverReview: builder.mutation({
            query: ({page,size,key}) => {
                const queryParams = new URLSearchParams({
                    page,
                    size
                });
    
                if (key) {
                    queryParams.append('searchKey', key);
                }
    
                const apiUrl = `driver-review/?${queryParams.toString()}`;

                return{
                    url: apiUrl,
                    method: "GET"
                }
            },
            transformResponse: (response) => {
                const items = response?.data ?? response?.content;

                if (items) {
                    return {
                        ...response,
                        content: items.map((item) => ({
                            ...item,
                            tourDriverId: item.driverUUID || item.tourDriverId,
                            averageRating: item.averageCriteria ?? item.averageRating,
                            profileImg: item.profile_img || item.profileImg || item.driver?.profile_img || item.driver?.profileImg || item.user_profile?.profile_img || item.userProfile?.profileImg,
                        })),
                        totalElements: response?.meta?.total ?? response?.totalElements,
                    };
                }
                return response;
            },
        }),
        updateDriverReview: builder.mutation({
            query: (data) => ({
                url: `driver-review/${data.reviewId}`,
                method: "PUT",
                body: {
                    criteriaPoints: data.criteriaPoints,
                    tourEndDate: data.endDate,
                    tourStartDate: data.startDate
                }
            }),
        }),
        deleteDriverReview: builder.mutation({
            query: (id) => ({
                url: `driver-review/${id}`,
                method: "DELETE",
                body: {}
            }),
        }),
        createDriverReview: builder.mutation({
            query: (data) => ({
                url: `driver-review`,
                method: "POST",
                body: {
                    criteriaPoints: data.criteriaPoints,
                    driverUUID: data.driverUUID,
                    tourRef: data.tourRef,
                    tourEndDate: data.endDate,
                    tourStartDate: data.startDate
                }
            }),
        }),
        getDriverInfoById: builder.mutation({
            query: (id) => ({
                url: `tour-driver/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        getDriverList: builder.query({
            query: () => ({
                url: `tour-driver/name`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
    }),
});

export const { useGetAllDriverReviewMutation, useDeleteDriverReviewMutation, useUpdateDriverReviewMutation, useCreateDriverReviewMutation, useGetDriverInfoByIdMutation, useGetDriverListQuery } = driverReviewAPI;
export default driverReviewAPI;
